var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUnits = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Units",
    transform: "translate(0 -50)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "code-compare-solid",
    d: "M13.11,19.992a.981.981,0,0,1-1.639.729l-3.277-2.95a.983.983,0,0,1,0-1.458l3.277-2.95a.981.981,0,0,1,1.639.729v1.639h.655a2.624,2.624,0,0,0,2.622-2.622V6.28a3.277,3.277,0,1,1,2.622,0V13.11a5.244,5.244,0,0,1-5.244,5.244H13.11ZM18.681,3.277a.983.983,0,1,0-.983.983A.983.983,0,0,0,18.681,3.277ZM7.866.983A.981.981,0,0,1,9.5.254L12.782,3.2a.983.983,0,0,1,0,1.458L9.5,7.612a.981.981,0,0,1-1.639-.729V5.244H7.21A2.624,2.624,0,0,0,4.588,7.866V14.7a3.277,3.277,0,1,1-2.622,0V7.866A5.244,5.244,0,0,1,7.21,2.622h.655ZM2.294,17.7a.983.983,0,1,0,.983-.983A.983.983,0,0,0,2.294,17.7Z",
    transform: "translate(14.683 64.683)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUnits);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Units.10f0810730e2a847d10e634b943d6877.svg";